import { useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "../../components/Hooks/axios";

const PersonaRedirect = () => {
  const { userId, token } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const res = await axios.get(`/persona/user-template/${userId}`);

        const templateId = res.data[0]?.templateId;

        if (!templateId || !token) {
          window.open(`/Home`, "_self");
        } else {
          window.open(
            `${process.env.REACT_APP_TEMPLATE_BASE_URL}/${userId}/${userId}/${token}`,
            "_self",
          );
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (userId) fetchTemplate();
  }, [userId, token]);

  return null;
};

export default PersonaRedirect;


